import { useCallback, useRef } from 'react';

import { useUser } from 'contexts/UserEnvironmentContext';
import { useElementReachedEffect } from 'hooks/viewport/useElementReachedEffect';
import { OpenWebWidgetLoadable } from 'modules/cms/components/Comments/OpenWebWidgetLoadable';
import type { ApiEvent } from 'modules/listing/api/event/types/ApiEvent';
import { ListingViewSection } from 'modules/listing/components/ListingView/Section/ListingViewSection';
import { trackEvent } from 'utils/analytics/track/trackEvent';

type Props = {
  listing: ApiEvent;
};

export function ListingViewCommentSection({ listing }: Props) {
  const atsRef = useRef<HTMLDivElement>(null);
  const { user } = useUser();

  useElementReachedEffect({
    ref: atsRef,
    onReach: useCallback(() => {
      trackEvent('Section View: Idealist Comments', {
        listing_type: listing.type,
        listing_id: listing.id,
        org_id: listing.org?.id || null,
        org_type: listing.org?.orgType || null,
      });
    }, [listing.id, listing.type, listing.org?.id, listing.org?.orgType]),
  });

  const listingUrl = listing.url[CURRENT_LOCALE()];
  const relativePath = listingUrl.startsWith('/')
    ? listingUrl.slice(1)
    : listingUrl;

  return (
    <ListingViewSection id="comments">
      <OpenWebWidgetLoadable
        postId={listing.id}
        relativePath={relativePath}
        userId={user ? user.id : undefined}
        hasIdealistProfileFeature={
          user ? Boolean(user.hasIdealistProfileFeature) : false
        }
        hasPublicProfile={user ? user.hasPublishedIdealistProfile : false}
      />
    </ListingViewSection>
  );
}
